<script>
    export default {
        props: {
            placeholder: null,
            value: null,
            multiple: false,
            apiUrl: null,
            debounceWait: {
                default: 400
            }
        },
        data() {
            return {
                options: [],
                loadInitialValue: false,
                disabled: false,
                selected: [],
            }
        },
        watch: {
            selected(value) {
                this.onChange(value);
            },
        },
        created() {
            this.getOptions();
        },
        methods: {
            getOptions() {
                this.disabled = true;

                axios.post(this.apiUrl).then((response) => {
                    this.options = response.data;
                    this.disabled = false;

                    if (this.value) {
                        this.setSelected();
                    }
                });
            },
            setSelected() {
                if (this.value.length === this.selected.length) {
                    return;
                }

                // Lazy load missing values
                this.disabled = true;
                axios.post(this.apiUrl, {ids: this.value}).then(response => {
                    this.options = _.uniqBy(_.merge(this.options, response.data), 'id');

                    this.updateSelected();
                });
                this.disabled = false;
            },
            updateSelected() {
                this.selected = [];

                let options = _.keyBy(this.options, 'id');
                let values = this.value;

                if (!_.isArray(this.value)) {
                    values = new Array(this.value);
                }

                _.each(values, (selected) => {
                    if (options[selected]) {
                        this.selected.push(options[selected]);
                    }
                });
            },
            onSearch(search, loading) {
                loading(true);
                this.search(loading, search, this);
            },
            onChange(options) {
                this.selected = options;

                if (Array.isArray(options)) {
                    return this.$emit('input', _.map(options, option => option.id.toString()));
                }

                this.$emit('input', options ? options.id.toString() : null);
            },
            search: _.debounce((loading, search, vm) => {
                axios.post(vm.apiUrl, {term: search}).then(res => {
                    vm.options = res.data;
                    loading(false);
                });
            }, 400, {leading: true, maxWait: 400}),
        }
    }
</script>

<template>
    <div>
        <v-select
                ref="select"
                :placeholder="placeholder"
                :multiple="multiple"
                :disabled="disabled"
                :options="options"
                v-model="selected"
                @search="onSearch"
        ></v-select>
    </div>
</template>
